export default __webpack_public_path__ + "static/media/profilePic.b8917fb9.svg";